import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {getLinkByType} from '@daedalus/core/src/offer/business/getLinkByType'
import {ActionLinkTypes} from '@daedalus/core/src/offer/types/actionLink'

import {useGetSapiRoom} from '../../hooks/useGetSapiRoom'
import {
  getIsFreezeOverlayOpen,
  getOfferEligibility
} from '../../modules/selector'
import {closeFreezeOverlay} from '../../modules/slice'
import {BrandBottomSheet} from '../BrandBottomSheet'
import {Content} from './Content'
import {OfferCheck} from './OfferCheck'
import {SkeletonLoading} from './SkeletonLoading'
import {Snowflake} from './Snowflake'
import {useTrackFreezeOverlayViewed} from './useTrackFreezeOverlayViewed'

const ContentWrapper = styled.div`
  min-height: 60vh;
`

const HeaderIcon = styled.div(
  ({theme}) => css`
    margin-top: ${theme.layout.spacing.s400}px;
    width: 64px;
    height: 64px;
    border: ${theme.layout.spacing.s100}px solid
      ${theme.colors.background.neutral.c000};
    border-radius: ${theme.layout.radius.rounded}px;
    background: ${theme.colors.background.brand.c100};
    display: flex;
    align-items: center;
    justify-content: center;
  `
)

export const FreezeBottomSheet = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(getIsFreezeOverlayOpen)
  const [isLoading, setIsLoading] = useState(true)
  const {isLoading: isOfferCheckLoading, isOfferEligible} =
    useSelector(getOfferEligibility)
  const {sapiRoomLoading, sapiMatchedOffer} = useGetSapiRoom({
    shouldSkip: !isOpen
  })

  useEffect(() => {
    setIsLoading(isOfferCheckLoading || sapiRoomLoading)
  }, [isOfferCheckLoading, sapiRoomLoading])

  useTrackFreezeOverlayViewed({isLoading, isOfferEligible})

  const offerLink = getLinkByType(
    sapiMatchedOffer?.links,
    ActionLinkTypes.CHECKOUT
  )

  const hideOverlay = () => dispatch(closeFreezeOverlay())

  return (
    <BrandBottomSheet
      isOpen={isOpen}
      isContentHeight
      iconComponent={
        <HeaderIcon>
          <Snowflake />
        </HeaderIcon>
      }
      onClose={hideOverlay}
    >
      <ContentWrapper>
        {isOpen && (
          <>
            {offerLink && <OfferCheck offerLink={offerLink} />}
            {isLoading && <SkeletonLoading />}
            {!isLoading && <Content />}
          </>
        )}
      </ContentWrapper>
    </BrandBottomSheet>
  )
}
